class Controller {
  constructor(Events, $stateParams, Sections) {
    "ngInject";

    this.activeParams = $stateParams;

    this.filterEvent = Events.getFilterEvent("loans");
    this.sortEvent = Events.getSortEvent("loans");
    this.paginateEvent = Events.getPaginateEvent("loans");

    this.page = $stateParams.page;
    this.limit = $stateParams.limit;
    this.sections = Sections.settingsSections;
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/loans/loans.controller.js